import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-4/4 place-items-end z-50 fixed bg-red-600 flow-root"
}
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "text-md" }
const _hoisted_4 = {
  key: 0,
  class: "text-md"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Detalle:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.data_alert.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-10/12 max-w-sm min-w-50 bg-white border-l-4 text-left p-4 absolute right-0", [$props.data_alert.type === 'success' ? ' border-green-500 text-green-700' : $props.data_alert.type === 'warning' ? ' border-yellow-500 text-yellow-700' : ' border-red-500 text-sirit_blue-700']]),
          role: "alert"
        }, [
          _createElementVNode("div", {
            class: "text-right",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeAlert()))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["cursor-pointer font-bold", [$props.data_alert.type === 'success' ? 'hover:text-green-400' : $props.data_alert.type === 'warning' ? 'hover:text-orange-400' : 'hover:text-sirit_blue-400' ]])
            }, "x", 2)
          ]),
          _createElementVNode("p", _hoisted_2, _toDisplayString($props.data_alert.title), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString($props.data_alert.msg), 1),
          ($props.data_alert.description !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString($props.data_alert.description), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}